import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        Version: '1.0.0',
        navbar: 0, // 导航
        user: null, // 登录的用户
        displayMode: 0, //设备显示方式，0卡片 1列表
        homeSelectShop: 0, //主页选择要查看的车间id
    },
    mutations: {
        upUser: (state, v) => (state.user = v),
        upNavbar: (state, v) => (state.navbar = v),
        displayMode: (state, v) => (state.displayMode = v),
        setHomeSelectShop: (state, v) => (state.homeSelectShop = v)
    }
});

export default store;



// WEBPACK FOOTER //
// ./src/store.js